<pdf-dark-theme *ngIf="theme === 'dark'"></pdf-dark-theme>
<pdf-light-theme *ngIf="theme === 'light'"></pdf-light-theme>
<pdf-acroform-default-theme></pdf-acroform-default-theme>

<pdf-dynamic-css [zoom]="mobileFriendlyZoomScale" [width]="toolbarWidthInPixels"></pdf-dynamic-css>
<ng-content *ngTemplateOutlet="customPdfViewer ? customPdfViewer : defaultPdfViewer"></ng-content>

<ng-template #defaultPdfViewer>
  <div class="zoom" [style.height]="minHeight ? minHeight : height" #root>
    <div class="html">
      <div class="body pdf-js-version-{{ majorMinorPdfJsVersion }}" [style.backgroundColor]="backgroundColor">
        <div id="outerContainer" (window:resize)="onResize()">
          <div class="free-floating-bar" *ngIf="showFreeFloatingBar">
            <ng-content *ngTemplateOutlet="customFreeFloatingBar ? customFreeFloatingBar : defaultFreeFloatingBar"> </ng-content>
          </div>
          <pdf-sidebar
            #pdfsidebar
            [sidebarVisible]="sidebarVisible || false"
            [showSidebarButton]="showSidebarButton"
            [customSidebar]="customSidebar"
            [customThumbnail]="customThumbnail"
            (thumbnailDrawn)="thumbnailDrawn.emit($event)"
            [mobileFriendlyZoomScale]="mobileFriendlyZoomScale"
            [sidebarPositionTop]="sidebarPositionTop"
          >
          </pdf-sidebar>
          <div id="mainContainer" [class.toolbar-hidden]="!primaryMenuVisible">
            <pdf-dummy-components></pdf-dummy-components>

            <pdf-toolbar
              (onToolbarLoaded)="onToolbarLoaded($event)"
              [sidebarVisible]="sidebarVisible"
              [class.server-side-rendering]="serverSideRendering"
              [customToolbar]="customToolbar"
              [mobileFriendlyZoomScale]="mobileFriendlyZoomScale"
              [(pageViewMode)]="pageViewMode"
              [primaryMenuVisible]="primaryMenuVisible"
              [scrollMode]="scrollMode ?? 0"
              [showPropertiesButton]="showPropertiesButton"
              [showBookModeButton]="showBookModeButton"
              [showDownloadButton]="showDownloadButton"
              [showDrawEditor]="showDrawEditor"
              [showHighlightEditor]="showHighlightEditor"
              [showFindButton]="showFindButton"
              [showHandToolButton]="showHandToolButton"
              [handTool]="handTool"
              [showHorizontalScrollButton]="showHorizontalScrollButton"
              [showInfiniteScrollButton]="showInfiniteScrollButton"
              [showOpenFileButton]="showOpenFileButton"
              [showPagingButtons]="showPagingButtons"
              [showPresentationModeButton]="showPresentationModeButton && pageViewMode !== 'book'"
              [showPrintButton]="showPrintButton && enablePrint"
              [showRotateCwButton]="showRotateCwButton"
              [showRotateCcwButton]="showRotateCcwButton"
              [showSecondaryToolbarButton]="showSecondaryToolbarButton && !service.secondaryMenuIsEmpty"
              [showSidebarButton]="showSidebarButton"
              [showSinglePageModeButton]="showSinglePageModeButton"
              [showSpreadButton]="showSpreadButton"
              [showStampEditor]="showStampEditor"
              [showTextEditor]="showTextEditor"
              [showVerticalScrollButton]="showVerticalScrollButton"
              [showWrappedScrollButton]="showWrappedScrollButton"
              [showZoomButtons]="showZoomButtons && pageViewMode !== 'book'"
              [spread]="spread"
              [textLayer]="textLayer"
              [toolbarMarginTop]="toolbarMarginTop"
              [toolbarWidth]="toolbarWidth"
              [zoomLevels]="zoomLevels"
              [findbarVisible]="findbarVisible"
            ></pdf-toolbar>

            <div class="editorParamsToolbar hidden doorHangerRight" id="editorHighlightParamsToolbar">
              <div id="highlightParamsToolbarContainer" class="editorParamsToolbarContainer">
                <div id="editorHighlightColorPicker" class="colorPicker">
                  <span id="highlightColorPickerLabel" class="editorParamsLabel" data-l10n-id="pdfjs-editor-highlight-colorpicker-label">Highlight color</span>
                </div>
                <div id="editorHighlightThickness">
                  <label for="editorFreeHighlightThickness" class="editorParamsLabel" data-l10n-id="pdfjs-editor-free-highlight-thickness-input"
                    >Thickness</label
                  >
                  <div class="thicknessPicker">
                    <input
                      type="range"
                      id="editorFreeHighlightThickness"
                      class="editorParamsSlider"
                      data-l10n-id="pdfjs-editor-free-highlight-thickness-title"
                      value="12"
                      min="8"
                      max="24"
                      step="1"
                    />
                  </div>
                </div>
                <div id="editorHighlightVisibility">
                  <div class="divider"></div>
                  <div class="toggler">
                    <label for="editorHighlightShowAll" class="editorParamsLabel" data-l10n-id="pdfjs-editor-highlight-show-all-button-label">Show all</label>
                    <button
                      id="editorHighlightShowAll"
                      class="toggle-button"
                      data-l10n-id="pdfjs-editor-highlight-show-all-button"
                      aria-pressed="true"
                    ></button>
                  </div>
                </div>
              </div>
            </div>

            <div class="editorParamsToolbar hidden doorHangerRight" id="editorFreeTextParamsToolbar" [class.server-side-rendering]="serverSideRendering">
              <div class="editorParamsToolbarContainer">
                <div class="editorParamsSetter">
                  <label for="editorFreeTextColor" class="editorParamsLabel" data-l10n-id="pdfjs-editor-free-text-color-input">Font Color</label>
                  <input type="color" id="editorFreeTextColor" class="editorParamsColor" />
                </div>
                <div class="editorParamsSetter">
                  <label for="editorFreeTextFontSize" class="editorParamsLabel" data-l10n-id="pdfjs-editor-free-text-size-input">Font Size</label>
                  <input type="range" id="editorFreeTextFontSize" class="editorParamsSlider" value="10" min="5" max="100" step="1" />
                </div>
              </div>
            </div>

            <div class="editorParamsToolbar hidden doorHangerRight" id="editorInkParamsToolbar" [class.server-side-rendering]="serverSideRendering">
              <div class="editorParamsToolbarContainer">
                <div class="editorParamsSetter">
                  <label for="editorInkColor" class="editorParamsLabel" data-l10n-id="pdfjs-editor-ink-color-input">Color</label>
                  <input type="color" id="editorInkColor" class="editorParamsColor" />
                </div>
                <div class="editorParamsSetter">
                  <label for="editorInkThickness" class="editorParamsLabel" data-l10n-id="pdfjs-editor-ink-thickness-input">Thickness</label>
                  <input type="range" id="editorInkThickness" class="editorParamsSlider" value="1" min="1" max="20" step="1" />
                </div>
                <div class="editorParamsSetter">
                  <label for="editorInkOpacity" class="editorParamsLabel" data-l10n-id="pdfjs-editor-ink-opacity-input">Opacity</label>
                  <input type="range" id="editorInkOpacity" class="editorParamsSlider" value="100" min="1" max="100" step="1" />
                </div>
              </div>
            </div>

            <pdf-secondary-toolbar
              #pdfSecondaryToolbarComponent
              [class.server-side-rendering]="serverSideRendering"
              [customSecondaryToolbar]="customSecondaryToolbar"
              [secondaryToolbarTop]="secondaryToolbarTop"
              [mobileFriendlyZoomScale]="mobileFriendlyZoomScale"
              (spreadChange)="onSpreadChange($event)"
              [localizationInitialized]="localizationInitialized"
            >
            </pdf-secondary-toolbar>

            <pdf-findbar
              [class.server-side-rendering]="serverSideRendering"
              [findbarLeft]="findbarLeft"
              [findbarTop]="findbarTop"
              [mobileFriendlyZoomScale]="mobileFriendlyZoomScale"
              [showFindButton]="showFindButton || false"
              [customFindbarInputArea]="customFindbarInputArea"
              [customFindbarButtons]="customFindbarButtons"
              [showFindCurrentPageOnly]="showFindCurrentPageOnly"
              [showFindEntirePhrase]="showFindEntirePhrase"
              [showFindEntireWord]="showFindEntireWord"
              [showFindFuzzySearch]="showFindFuzzySearch"
              [showFindHighlightAll]="showFindHighlightAll"
              [showFindMatchDiacritics]="showFindMatchDiacritics"
              [showFindMatchCase]="showFindMatchCase"
              [showFindMessages]="showFindMessages"
              [showFindPageRange]="showFindPageRange"
              [showFindResultsCount]="showFindResultsCount"
            >
            </pdf-findbar>

            <pdf-context-menu></pdf-context-menu>

            <div id="viewerContainer" [style.top]="viewerPositionTop" [style.backgroundColor]="backgroundColor" role="document">
              <div class="unverified-signature-warning" *ngIf="hasSignature && showUnverifiedSignatures">
                {{
                  'unverified-signature-warning'
                    | translate
                      : "This PDF file contains a digital signature. The PDF viewer can't verify if the signature is valid.
                Please download the file and open it in Acrobat Reader to verify the signature is valid."
                    | async
                }}
              </div>
              <div id="viewer" class="pdfViewer" (dblclick)="zoomToPageWidth($event)"></div>
            </div>
            <pdf-error-message></pdf-error-message>
          </div>
          <!-- mainContainer -->

          <div id="dialogContainer">
            <pdf-password-dialog></pdf-password-dialog>
            <pdf-document-properties-dialog></pdf-document-properties-dialog>
            <pdf-alt-text-dialog></pdf-alt-text-dialog>
            <pdf-prepare-printing-dialog></pdf-prepare-printing-dialog>
          </div>
          <!-- dialogContainer -->
        </div>
        <!-- outerContainer -->
        <div id="printContainer"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultFreeFloatingBar> </ng-template>
